import { collection, addDoc, serverTimestamp } from 'firebase/firestore'
import { db } from '@/firebase'
import { useAuthStore } from '@/stores/auth'

export async function writeAuditLog(
  incidentId: string,
  action: string,
  entityType: string,
  entityId: string,
  before: Record<string, unknown> | null,
  after: Record<string, unknown> | null,
): Promise<void> {
  const authStore = useAuthStore()
  if (!authStore.userProfile) return
  await addDoc(collection(db, 'incidents', incidentId, 'audit_log'), {
    user_id: authStore.userProfile.user_id,
    user_name: `${authStore.userProfile.user_first_name} ${authStore.userProfile.user_last_name}`,
    action,
    entity_type: entityType,
    entity_id: entityId,
    before,
    after,
    timestamp: serverTimestamp(),
  })
}
